export function getEmptyOrg() {
  return {
    id: '',
    name: '',
  }
}
